import {
    LEAGUES_ACTIVE_TEAMS_FAILURE,
    LEAGUES_ACTIVE_TEAMS_REQUEST,
    LEAGUES_ACTIVE_TEAMS_SUCCESS,
    LEAGUES_DASHBOARD_TEAMS_FAILURE,
    LEAGUES_DASHBOARD_TEAMS_REQUEST,
    LEAGUES_DASHBOARD_TEAMS_SUCCESS,
} from './actionTypes/leagues-action-types';
import { getLeagueTeams, getDashboardTeams } from '../api/leaguesApi';

export function getDashboardLeagueTeams() {
    return async (dispatch, getState, { leaguesApi }) => {
        dispatch({ type: LEAGUES_DASHBOARD_TEAMS_REQUEST });
        try {
            const res = await getDashboardTeams(leaguesApi);
            const { data } = res;
            if (data.error) {
                dispatch({ type: LEAGUES_DASHBOARD_TEAMS_FAILURE });
            } else {
                dispatch({ type: LEAGUES_DASHBOARD_TEAMS_SUCCESS, data });
            }
        } catch (error) {
            dispatch({ type: LEAGUES_DASHBOARD_TEAMS_FAILURE, error });
        }
    };
}

export function getActiveLeagueTeams() {
    return async (dispatch, getState, { leaguesApi }) => {
        dispatch({ type: LEAGUES_ACTIVE_TEAMS_REQUEST });
        try {
            const res = await getLeagueTeams(leaguesApi, true);
            const { data } = res;
            if (data.error) {
                dispatch({ type: LEAGUES_ACTIVE_TEAMS_FAILURE });
            } else {
                dispatch({ type: LEAGUES_ACTIVE_TEAMS_SUCCESS, data });
            }
        } catch (error) {
            dispatch({ type: LEAGUES_ACTIVE_TEAMS_FAILURE });
        }
    };
}
